import { AdminSubheader } from "features/AdminSubheader";

export function DiscoverSubheader() {
	return <AdminSubheader items={[
		// {
		// 	label: "Games",
		// 	link: "/discover/game"
		// },
		{
			label: "Games",
			link: "/discover/v2/games"
		},
		{
			label: "Clubs",
			link: "/discover/club"
		},
		{
			label: "Teams",
			link: "/discover/team"
		},
		{
			label: "Players",
			link: "/discover/player-data"
		},
		{
			label: "Users",
			link: "/discover/user"
		},
		{
			label: "Sign-up(s)",
			link: "/discover/sign-up"
		},
		{
			label: "Tokens",
			link: "/discover/token-movements"
		},
	]} />
}
